import { gql } from '@apollo/client/core';

export const GETTING_STARTED_REQUESTS_QUERY = gql`
  query InvitedSitters($accountId: UUID!) {
    account(id: $accountId) {
      ... on Parent {
        jobs(first: 1, jobStatuses: [OPEN, EXPIRED], careTypes: [BABYSITTER, NANNY, SPECIAL_NEEDS]) {
          edges {
            node {
              hasRecruitedSittersForJob
              careType
              distance
              location {
                zipcode
              }
              paymentRateMax
              expiresAt
            }
          }
        }
      }
    }
  }
`;

export const REQUESTS_QUERY = gql`
  query ($kind: AccountKind!, $after: String) {
    viewer(kind: $kind) {
      requests(first: 10, after: $after) {
        pageInfo {
          hasNextPage
        }
        totalCount
        edges {
          cursor
          node {
            id
            start
            end
            expiry
            interviewRequestKind
            invitedSitters {
              email
            }
            identifiedSitters {
              sitter {
                id
                name
                photoUrl
                ... on Sitter {
                  viewerHasMessaged
                }
              }
            }
            parent {
              id
              name
              photoUrl
            }
            scCareSession {
              careGiverValidationStatus
              recipientCount
              individualCareRecipientDetails {
                firstName
                startDateTime
                endDateTime
                status
              }
            }
          }
        }
      }
    }
  }
`;

export const CONTRACTS_QUERY = gql`
  query ($kind: AccountKind!, $after: String) {
    viewer(kind: $kind) {
      upcomingContracts(first: 10, after: $after) {
        pageInfo {
          hasNextPage
        }
        totalCount
        edges {
          cursor
          node {
            scCareSession {
              careGiverValidationStatus
              recipientCount
              individualCareRecipientDetails {
                firstName
                startDateTime
                endDateTime
                status
              }
            }
            id
            start
            end
            interviewContractKind
            kind
            parent {
              id
              name
              photoUrl
            }
            sitter {
              id
              name
              photoUrl
              ... on Sitter {
                viewerHasMessaged
              }
            }
          }
        }
      }
    }
  }
`;

export const COMPLETED_CONTRACTS_QUERY = gql`
  query completedContractsQuery($kind: AccountKind!, $after: String, $careGiverValidationStatus: CareGiverValidationStatusEnum) {
    viewer(kind: $kind) {
      ... on Sitter {
        providerType
      }
      ... on Parent {
        id
        careType
        location {
          zipcode
        }
      }
      completedContracts(first: 10, after: $after, careGiverValidationStatus: $careGiverValidationStatus) {
        pageInfo {
          hasNextPage
        }
        totalCount
        edges {
          cursor
          node {
            scCareSession {
              careGiverValidationStatus
            }
            id
            start
            end
            interviewContractKind
            kind
            parent {
              id
              name
              photoUrl
            }
            sitter {
              id
              name
              photoUrl
              ... on Sitter {
                viewerHasMessaged
              }
            }
          }
        }
      }
    }
  }
`;

export const BOOKINGS_QUERY = gql`
  query ($kind: AccountKind!) {
    viewer(kind: $kind) {
      ... on Sitter {
        providerType
      }
      ... on Parent {
        id
        careType
        location {
          zipcode
        }
      }
      photoUrl
      requests {
        totalCount
      }
      completedContracts {
        totalCount
      }
      upcomingContracts {
        totalCount
      }
    }
  }
`;

export const PARENT_CONTRACT_QUERY = gql`
  query ($id: UUID!) {
    contract(id: $id) {
      __typename
      id
      start
      kind
      end
      interviewContractKind
      sitter {
        id
        name
        photoUrl
        phoneNumber
        accountNote {
          notes
        }
        ... on Sitter {
          viewerHasMessaged
        }
      }
      parent {
        id
        name
        photoUrl
      }
      location {
        details
        virtual
        geoPoint {
          x
          y
        }
      }
      familyMembers {
        birthDate
        name
      }
      details
      petInfo
      rate
      scCareSession {
        careGiverValidationStatus
        recipientCount
        individualCareRecipientDetails {
          firstName
          startDateTime
          endDateTime
          status
        }
      }
    }
  }
`;

export const SITTER_CONTRACT_QUERY = gql`
  query ($id: UUID!) {
    contract(id: $id) {
      scCareSession {
        careGiverValidationStatus
        recipientCount
        careType
        individualCareRecipientDetails {
          firstName
          startDateTime
          endDateTime
          status
        }
      }
      __typename
      id
      start
      kind
      end
      interviewContractKind
      sitter {
        id
        name
        photoUrl
        phoneNumber
      }
      parent {
        id
        name
        photoUrl
        ... on Parent {
          viewerHasMessaged
        }
      }
      location {
        details
        virtual
        geoPoint {
          x
          y
        }
      }
      familyMembers {
        birthDate
        name
      }
      details
      petInfo
      rate
    }
  }
`;
